const state = {
  customForms: [],
  id: '',
  title: '',
  questions: [],
  questionDefaultPayload: {
    id: '',
    title: '',
    is_required: false,
    type: '',
    answers: [
      {
        id: '',
        answer: '',
        is_correct: false,
      },
    ],
  },
};


const mutations = {
  addQuestion: (st, data) => {
    st.questions.push(data);
  },
  resetFormState: (st) => {
    st.questions = [];
  },
  setCustomForms: (st, data) => {
    st.customForms = data;
  },
  removeQuestion: (st, data) => {
    st.questions.splice(data, 1);
  },
  resetQuestions: (st) => {
    st.questions = [];
  }
};

const actions = {
  addQuestion({ commit }, payload) {
    commit('addQuestion', payload);
  },
  resetQuestions({ commit }) {
    commit('resetQuestions');
  },
  removeQuestion({ commit }, payload) {
    commit('removeQuestion', payload);
  },
  resetFormState({ commit }) {
    commit('resetFormState');
  },
  setCustomForms({ commit }, payload) {
    commit('setCustomForms', payload);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
